import { render } from "./ProfileComponent.vue?vue&type=template&id=9dc02e3a&ts=true"
import script from "./ProfileComponent.vue?vue&type=script&lang=ts"
export * from "./ProfileComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__